import HeroBanner from "../../HeroBanner";

const HeroSection = () => {
  return (
    <section id="hero" className="px-5 sm:px-10 xl:px-20">
      <div className="w-full">
        {/* <img
          src="images/LockerDashBig.svg"
          height={324}
          alt="lockerdash_banner"
          className="w-full md:block hidden "
        /> */}
        <HeroBanner />
        {/* <img
          src="images/LockerDashSmall.svg"
          alt="lockerdash_banner"
          className="w-full md:hidden block"
        /> */}
      </div>
      <div className="flex justify-center xl:px-0 bmd:px-6">
        <div className="mt-14 xl:w-[90%] bmd:flex-row flex-col  bmd:space-y-0 space-y-5 flex bmd:items-center bmd:space-x-3 bmd:justify-between">
          <h3 className="lg:text-5xl text-2xl sm:text-4xl sm:space-y-3  text-[#17730A]">
            <p className="font-worksans text-[#0E1728]">Fez SafeLockers- </p>
            <p className="font-worksans">Convenient, Secure,</p>
            <p className="font-worksans">Hassle-Free Pickups</p>
          </h3>
          <div className="bmd:w-[50%] space-y-4">
            <p className="font-onest text-[#464748] bmd:text-lg">
              We are excited to introduce LockerDash, an offer that helps you
              deliver faster, safer, and smarter with our Safe Lockers network
              across Lagos and Abuja.
            </p>
            <p className="font-onest text-[#464748] bmd:text-lg">
              Fez Safe Lockers are secure, self-service stations where you can
              pick up deliveries anytime. They are fully trackable and offer a
              fast, contactless way to receive packages — no missed calls or
              failed deliveries.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
